import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import { Link, useLocation } from "react-router-dom";
import smallLogo from "../../smallLogo.svg";

const pages = [
  {
    pageName: "Services",
    path: "/services",
  },
  {
    pageName: "Projecten",
    path: "/projecten",
  },
  {
    pageName: "Contact",
    path: "/contact",
  },
];

function ResponsiveAppBar() {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const location = useLocation();

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  return (
    <AppBar 
      position="sticky" 
      sx={{ 
        backgroundColor: 'rgba(255,255,255,0.96)',
        color: 'primary.main',
        backdropFilter: 'blur(14px)',
        boxShadow: '0 2px 18px rgba(31,41,36,0.08)',
      }}
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Box
            component={Link}
            to="/"
            sx={{
              display: 'flex',
              alignItems: 'center',
              textDecoration: 'none',
              color: 'inherit',
              transition: 'opacity 0.3s ease',
              '&:hover': {
                opacity: 0.8,
              },
            }}
          >
            <Box
              component="img"
              src={smallLogo}
              alt="logo"
              sx={{
                height: { xs: '8vh', md: '10vh' },
                maxHeight: 72,
                display: 'block',
              }}
            />
            <Typography 
              variant="h6" 
              component="div" 
              sx={{ 
                ml: 2,
                fontWeight: 700,
                letterSpacing: '0.5px',
                fontSize: { xs: '1rem', md: '1.25rem' },
              }}
            >
              Meester Stoffeerders
            </Typography>
          </Box>

          {/* Desktop Menu */}
          <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" }, ml: 3, gap: 1 }}>
            {pages.map((page) => (
              <Button
                key={page.pageName}
                component={Link}
                to={page.path}
                onClick={handleCloseNavMenu}
                sx={{ 
                  my: 2, 
                  color: "primary.main", 
                  display: "block",
                  position: 'relative',
                  fontWeight: 600,
                  '&::after': {
                    content: '""',
                    position: 'absolute',
                    bottom: 8,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: location.pathname === page.path ? '80%' : '0%',
                    height: '3px',
                    backgroundColor: 'secondary.main',
                    transition: 'width 0.3s ease',
                  },
                  '&:hover::after': {
                    width: '80%',
                  },
                  '&:hover': {
                    backgroundColor: 'rgba(154,98,64,0.08)',
                  }
                }}
              >
                {page.pageName}
              </Button>
            ))}
          </Box>

          {/* Mobile Menu */}
          <Box sx={{ display: { xs: "flex", md: "none" }, ml: 'auto' }}>
            <IconButton
              size="large"
              aria-label="menu"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: "block", md: "none" },
              }}
            >
              {pages.map((page) => (
                <MenuItem 
                  key={page.pageName} 
                  onClick={handleCloseNavMenu}
                  sx={{
                    backgroundColor: location.pathname === page.path ? 'action.selected' : 'transparent',
                  }}
                >
                  <Typography textAlign="center">
                    <Link
                      to={page.path}
                      style={{ 
                        textDecoration: "none", 
                        color: "inherit",
                        fontWeight: location.pathname === page.path ? 600 : 400,
                      }}
                    >
                      {page.pageName}
                    </Link>
                  </Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default ResponsiveAppBar;
